<template>
  <div>
    <!-- top -->
    <a-row class="chooseDate" type="flex" justify="space-around" align="middle">
      <a-col :span="10">
        <div class="name">
          对账单
        </div>
        <div>
          {{ checkDate }}
        </div>
      </a-col>
      <a-col :span="14">
        <a-button type="primary" class="submitBtn" @click="handleConfirm">
          确认账单
        </a-button>
        <a-button type="primary" class="submitBtn downloadBtn" @click="handleDownload">
          导出
        </a-button>
        <a-button type="" class="submitBtn downloadBtn" @click="backPage">
          返回
        </a-button>
      </a-col>
    </a-row>
    <!--  -->
    <a-table
      :columns="columns"
      bordered
      :data-source="BillDetail"
      :pagination="false"
      :row-key="(r) => r.id"
      :loading="loading"
      style="font-size:12px"
    >
      <template v-slot:orderNo="{ text, record }">
        <div>{{ record.orderNo }}</div>
      </template>
      <template v-slot:checkStateValue="{ text, record }">
        <a-tooltip v-if="record.checkState == 90" placement="bottomRight">
          <template #title>
            {{ record.exReason }}
          </template>
          <span class="exReasonStyle">{{ record.checkStateValue }}</span>
        </a-tooltip>
        <div v-else>{{ record.checkStateValue }}</div>
      </template>

        <template v-slot:settlementAmount="{ text, record }">
            <div v-if="record.settlementAmount != null">
                ¥
                {{
                record.ticketTypeValue == "退票" || record.ticketTypeValue == "改签退票"
                ? "-" + record.settlementAmount
                : record.settlementAmount
                }}
            </div>
        </template>

      <template v-slot:operation="{ text, record }">
        <a-button
          type="danger"
          @click="handleDelete(record)"
          size="small"
          style="margin-right:10px"
          v-show="record.importId != null"
        >
          删除
        </a-button>
      </template>
    </a-table>
    <a-pagination
      v-show="BillDetail.length"
      v-model:current="current"
      :total="total"
      :page-size="10"
      @change="pageChange"
      :show-total="(total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`"
    />
  </div>
</template>
<script>
import { ref, watch, createVNode } from "vue";
import { useRouter, useRoute } from "vue-router";
import myApi from "@axios/my";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import { CaretDownOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";

export default {
  name: "billListDetail",
  components: {
    CaretDownOutlined,
    ExclamationCircleOutlined
  },
  setup() {
    let router = useRouter();
    const route = useRoute();
    const billNo = route.query.billNo;
    const id = route.query.id;
    const supplierId = route.query.supplierId;
    const checkTime = route.query.checkTime;
    const checkDate = route.query.checkDate;

    let loading = ref(false);

    let BillDetail = ref([]);

    let current = ref(1);
    let total = ref(0);

    const getBillDetail = () => {
      if (loading.value) {
        return;
      }
      let params = {
        size: 10,
        currentPage: current.value,
        billNo: billNo
      };
      loading.value = true;
      myApi
        .getBillDetail(params)
        .then((res) => {
          BillDetail.value = res.data;
          current.value = res.currentPage;
          total.value = res.total;

          loading.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const pageChange = (page) => {
      current.value = page;
      getBillDetail();
    };

    const toDetail = (code) => {
      router.push({
        name: "orderDetail",
        query: {
          orderCode: code
        }
      });
    };

    getBillDetail();

    // 确认账单
    const handleConfirm = () => {
      Modal.confirm({
        title: "是否确认账单？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          myApi.confirmBill(id).then((res) => {
            console.log(res);
            message.success("完结成功");
            getList();
          });
        },
        onCancel() {}
      });
    };

    // 导出
    // 导出
    const handleDownload = () => {
      let params = {
        billNo: billNo
      };
      let fileName = "帐单-" + billNo;
      exportOut(
        params, // 导出请求参数
        "/business-finance/distributor/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 删除供应明细
    const handleDelete = (item) => {
      console.log(item);
      Modal.confirm({
        title: "是否确认删除？",
        icon: createVNode(ExclamationCircleOutlined),
        content: "",
        onOk() {
          myApi.delBillDetail(item.importId).then((res) => {
            console.log(res);
            message.success("删除成功");
            getList();
          });
        },
        onCancel() {}
      });
    };

    // 返回
    const backPage = () => {
      router.back();
    };

    return {
      toDetail,
      pageChange,
      total,
      BillDetail,
      loading,
      current,
      columns: [
          {
              title: "出票/改签/退票时间",
              dataIndex: "ticketTime",
              // width: 80,
              align: "center"
          },
          {
              title: "票号",
              dataIndex: "ticketNo",
              // width: 80,
              align: "center"
          },
          {
              title: "票种类型",
              dataIndex: "ticketTypeValue",
              // width: 100,
              align: "center"
          },
          {
              title: "改签类型",
              dataIndex: "changeTypeValue",
              align: "center"
          },
        {
          title: "订单号",
          dataIndex: "",
          // width: 100,
          align: "center",
          slots: { customRender: "orderNo" }
        },
          {
              title: "原订单号",
              dataIndex: "changesNo",
              // width: 100,
              align: "center",
              slots: { customRender: "changesNo" }
          },
          {
              title: "退票单号",
              dataIndex: "returnNo",
              // width: 100,
              align: "center",
              slots: { customRender: "returnNo" }
          },
          {
              title: "渠道订单号",
              dataIndex: "channelCode",
              // width: 100,
              align: "center",
              slots: { customRender: "channelCode" }
          },
        {
          title: "结算金额",
          dataIndex: "settlementAmount",
          // width: 80,
          align: "center",
            slots: { customRender: "settlementAmount" },
        },
          {
              title: "票款",
              dataIndex: "ticketAmount",
              // width: 80,
              align: "center"
          },
          {
              title: "票数",
              dataIndex: "ticketCount",
              // width: 80,
              align: "center"
          },
        {
          title: "手续费",
          dataIndex: "returnServiceAmount",
          // width: 80,
          align: "center"
        },
          {
              title: "出票模式",
              dataIndex: "ticketModeValue",
              //width: 100,
              align: "center",
          },
          {
              title: "乘客姓名",
              dataIndex: "passengerName",
              width: 100,
              align: "center",
          },
          {
              title: "乘客类型",
              dataIndex: "passengerTypeValue",
             // width: 100,
              align: "center",
          },
          {
              title: "出发日期",
              dataIndex: "trainTime",
              //width: 200,
              align: "center",
          },
          {
              title: "出发站",
              dataIndex: "fromStation",
             // width: 100,
              align: "center",
          },
          {
              title: "到达站",
              dataIndex: "toStation",
             // width: 100,
              align: "center",
          },
          {
              title: "车次号",
              dataIndex: "trainNo",
            //  width: 100,
              align: "center",
          },
          {
              title: "票根打印",
              dataIndex: "enterpriseCodeValue",
              //  width: 100,
              align: "center",
          },
        /*{
          title: "手续费",
          dataIndex: "serviceAmount",
          // width: 80,
          align: "center"
        },*/
        /*{
          title: "票数",
          dataIndex: "",
          // width: 80,
          align: "center"
        },
*/
        {
          title: "对账状态",
          dataIndex: "checkStateValue",
          // width: 80,
          align: "center",
          slots: { customRender: "checkStateValue" }
        },
        /*{
          title: "操作",
          dataIndex: "",
          // width: 80,
          align: "center",
          slots: { customRender: "operation" }
        }*/
      ],
      handleDownload,
      backPage,
      handleConfirm,
      checkTime,
      handleDelete,
        checkDate
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.orderCode_span {
  // color:#0D6DBF;
  cursor: pointer;
}
.changeType {
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  // font-weight: 600;
  color: #000000;
}
.first_p {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
}
.chooseDate {
  background: #f8f8f8;
  padding: 8px 22px 7px;
  margin-bottom: 12px;
  .ant-col-10 {
    text-align: left;
    .name {
      font-weight: 700;
    }
  }
  .ant-col-14 {
    text-align: right;
  }
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-left: 17px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    border-radius: 4px;
  }
  .downloadBtn {
    background: #409eff !important;
    border-color: #409eff !important;
  }
}
.item_content {
  padding: 0 16px 0 20px;
}
.item_content:hover {
  background: #e6f7ff !important;
}
.amount-list {
  margin-top: 13px;
  // padding: 0 16px 0 20px;
  border: 0.5px solid #dbdce0;
  padding: 6px 0;
  // padding-bottom: 250px;
  .item {
    padding: 15px 0 6px 0;
    border-bottom: 1px solid #dbdce0;
    .item-left {
      & div {
        display: inline-block;
      }
      .changeType {
        vertical-align: top;
        font-size: 14px;
        line-height: 22px;
        margin-right: 22px;
      }
      .info {
        color: #000000;
        font-family: PingFangSC-Light, PingFang SC;
        font-size: 14px;
        line-height: 20px;

        & span:nth-of-type(2) {
          font-family: PingFangSC-Light, PingFang SC;
          color: #929395;
        }
      }
    }
    .item-right {
      text-align: right;
      font-size: 16px;
      line-height: 22px;
      color: #929395;
    }
  }
  .item_content:last-of-type {
    .item {
      border: none;
    }
  }
  .ant-pagination {
    text-align: center;
    margin-top: 40px !important;
  }
}
.exReasonStyle {
  cursor: pointer;
  color: #ffab00;
  // text-decoration: underline;
}
</style>
